import { render, staticRenderFns } from "./PackageTag.vue?vue&type=template&id=53a3042f&scoped=true"
import script from "./PackageTag.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PackageTag.vue?vue&type=style&index=0&id=53a3042f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3042f",
  null
  
)

export default component.exports